import { defineComponent as _defineComponent } from 'vue';
import Sidebar from 'primevue/sidebar';
import { ref, reactive, watchEffect, defineAsyncComponent, shallowRef, } from 'vue';
import { useMitt } from '../Plugins/mitt';
import { usePageProps } from '../Plugins/page-props';
import { useToastService } from '../Plugins/toast-service';
import { FormPanel } from '../@types/Enums';
import { trans } from 'laravel-vue-i18n';
import SymptomRecordService from '../Services/SymptomRecordService';
import { useSpinner } from '../Plugins/spinner';
export default /*#__PURE__*/ _defineComponent({
    __name: 'FormPanels',
    setup(__props, { expose }) {
        expose();
        const FertilizationForm = defineAsyncComponent(() => import('@/Pages/Orchard/Plots/Fertilizations/EditCreate.vue'));
        const IrrigationForm = defineAsyncComponent(() => import('@/Pages/Orchard/Plots/Irrigations/EditCreate.vue'));
        const IrrigationWaterData = defineAsyncComponent(() => import('@/Pages/Orchard/IrrigationWaterData/EditCreate.vue'));
        const PlotForm = defineAsyncComponent(() => import('@/Pages/Orchard/Plots/EditCreate.vue'));
        const OrchardDetailsForm = defineAsyncComponent(() => import('@/Pages/Orchard/OrchardDetailsForm.vue'));
        const SoilDataform = defineAsyncComponent(() => import('@/Pages/Orchard/SoilData/EditCreate.vue'));
        const LeavesDataForm = defineAsyncComponent(() => import('@/Pages/Orchard/LeavesData/EditCreate.vue'));
        const SymptomRecordForm = defineAsyncComponent(() => import('@/Pages/Orchard/SymptomRecords/EditCreate.vue'));
        const forms = {
            [FormPanel.Irrigation]: IrrigationForm,
            [FormPanel.Plot]: PlotForm,
            [FormPanel.IrrigationWaterData]: IrrigationWaterData,
            [FormPanel.OrchardDetailsForm]: OrchardDetailsForm,
        };
        const pageProps = usePageProps();
        const toast = useToastService();
        const company = pageProps.company();
        const selectedForm = shallowRef();
        const sidebarVisible = ref(false);
        watchEffect(() => (sidebarVisible.value = selectedForm.value !== undefined));
        const emitter = useMitt();
        const symptomRecordService = new SymptomRecordService();
        const spinner = useSpinner();
        const onSaved = (data) => {
            sidebarVisible.value = false;
            toast.storeSuccess();
        };
        const panelLabel = (formName, data, suffix = '') => {
            let transKey = `panels.${formName}.`;
            transKey += data && data.id ? 'edit_title' : 'create_title';
            return trans(transKey) + suffix;
        };
        emitter.off('open-form-panel');
        emitter.on('open-form-panel', (data) => (selectedForm.value = data));
        emitter.off('open-form-panel-enum');
        emitter.on('open-form-panel-enum', (data) => {
            selectedForm.value = {
                label: panelLabel(data.form, data.data),
                component: forms[data.form],
                data: data.data,
            };
        });
        emitter.off('open-fertilization-form');
        emitter.on('open-fertilization-form', (data) => {
            const label = panelLabel('FertilizationForm', data);
            selectedForm.value = {
                label,
                component: FertilizationForm,
                data,
            };
        });
        emitter.off('open-irrigation-form');
        emitter.on('open-irrigation-form', (data) => {
            const label = panelLabel('IrrigationForm', data);
            selectedForm.value = {
                label,
                component: IrrigationForm,
                data,
            };
        });
        emitter.off('open-irrigation-water-data-form');
        emitter.on('open-irrigation-water-data-form', (data) => {
            const suffix = data && data.id ? `: ${data.code}` : '';
            const label = panelLabel('IrrigationWaterDataForm', data, suffix);
            selectedForm.value = {
                label,
                component: IrrigationWaterData,
                data,
            };
        });
        emitter.off('open-leaves-data-form');
        emitter.on('open-leaves-data-form', (data) => {
            const suffix = data && data.id ? `: ${data.code}` : '';
            const label = panelLabel('LeavesDataForm', data, suffix);
            selectedForm.value = {
                label,
                component: LeavesDataForm,
                data,
            };
        });
        emitter.off('open-soil-data-form');
        emitter.on('open-soil-data-form', (data) => {
            const suffix = data && data.id ? `: ${data.code}` : '';
            const label = panelLabel('SoilDataForm', data, suffix);
            selectedForm.value = {
                label,
                component: SoilDataform,
                data,
            };
        });
        emitter.off('open-symptom-record-form');
        emitter.on('open-symptom-record-form', async (data) => {
            if (data?.id) {
                spinner.show();
                data = reactive(await symptomRecordService.getById(data.id));
                spinner.hide();
            }
            const suffix = data && data.id ? `: ${data.code}` : '';
            const label = panelLabel('SymptomRecordForm', data, suffix);
            selectedForm.value = {
                label,
                component: SymptomRecordForm,
                data,
            };
        });
        const __returned__ = { FertilizationForm, IrrigationForm, IrrigationWaterData, PlotForm, OrchardDetailsForm, SoilDataform, LeavesDataForm, SymptomRecordForm, forms, pageProps, toast, company, selectedForm, sidebarVisible, emitter, symptomRecordService, spinner, onSaved, panelLabel, get Sidebar() { return Sidebar; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
